<template>
    <div class="land-nav" v-if="salesCardPage != null && salesCard != null" id="landNav" :class="{'initHeaderInfo' : projectHost == 'yassytower'}">
        <div class="container">
            <ul class="nav-list" :class="{'kohota-nav': projectHost == 'kohota'}">
                <li v-if="salesCard.project_land_site.about_init == 'true'"><a :href="salesCardPage.land_site_nav[0].link" 
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[0].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[0].name}}</a></li>
                <li v-if="salesCard.project_land_site.location_init == 'true'"><a :href="salesCardPage.land_site_nav[1].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[1].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[1].name}}</a></li>
                <li v-if="salesCard.project_land_site.genplan_init == 'true'"><a :href="salesCardPage.land_site_nav[2].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[2].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[2].name}}</a></li>
                <li v-if="salesCard.project_land_site.prems_init == 'true'"><a :href="salesCardPage.land_site_nav[3].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[3].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[3].name}}</a></li>
                <li v-if="salesCard.project_land_site.arch_init == 'true'"><a :href="salesCardPage.land_site_nav[4].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[4].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[4].name}}</a></li>
                <!-- FLATS -->
                <li v-if="salesCard.project_land_site.flats_init == 'true' && projectHost != 'yassytower'"><a :href="salesCardPage.land_site_nav[5].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[5].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[5].name}}</a></li>
                <li v-if="salesCard.project_land_site.flats_init == 'true' && projectHost == 'yassytower'"><a :href="salesCardPage.land_site_nav[5].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[5].link,
                        offset: -100
                    }">Планировки</a></li>
                <!-- END FLATS -->
                <li v-if="salesCard.project_land_site.gallery_init == 'true'"><a :href="salesCardPage.land_site_nav[6].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[6].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[6].name}}</a></li>
                <li v-if="salesCard.project_land_site.news_init == 'true'"><a :href="salesCardPage.land_site_nav[7].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[7].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[7].name}}</a></li>
                <li v-if="salesCard.project_land_site.contacts_init == 'true'"><a :href="salesCardPage.land_site_nav[8].link"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[8].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[8].name}}</a></li>
            </ul>
            <div class="header-info" v-if="projectHost == 'yassytower'">
                <div class="lang">
                    <div class="lang--picker">
                        <a href="#" class="lang-link-select" @click.prevent="openSelectLang = !openSelectLang">
                            <span class="body-lang-ru" v-if="dataLang == ''">Рус</span>
                            <span class="body-lang-kz" v-else>Каз</span>
                        </a>
                    </div>
                    <div class="select--languages dropdown-menu" :class="{'open' : openSelectLang}">
                        <ul>
                            <li class="select-link select-link-ru" :class="{'active': dataLang == ''}">
                                <a href="#" @click.prevent="setLocale(''), openSelectLang = !openSelectLang">Рус</a>
                            </li>
                            <li class="select-link select-link-kz" :class="{'active': dataLang != ''}">
                                <a href="#" @click.prevent="setLocale('kz/'), openSelectLang = !openSelectLang">Каз</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="city-select">
                    <div class="city-picker" v-if="currentPhone != null">
                        <a href="#" class="city-link-picker" @click.prevent>
                            <span>{{currentPhone.region}}</span>
                        </a>
                    </div>
                </div>
                <div class="phone-current-city" v-if="currentPhone != null">
                    <a :href="'tel:' + currentPhone.region_phone" class="phone-number">{{currentPhone.region_phone}}</a>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-nav',
        components: {
        },
        data () {
            return {
                projectHost: window.host,
                regionCity: null,
                regionCityArr: null, 
                dropdownCity: false,
                iSmobile: false,
                currentPhone: null,
                openSelectLang: false,
                dataLang: '',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            setup: 'loadPageSetUp',
            currentCity: 'loadCurCity',
            openSendwich: 'loadOpenSendwich',
        }),
        methods: {
            filterPhoneCity() {
                if (this.setup != null && this.currentCity != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug == this.currentCity.slug;
                    });
                    // console.log(filteredItems, 'CURRENT PHONE');
                    if (filteredItems.length > 0) {
                        this.currentPhone = filteredItems[0];
                    } else  {
                        console.log('length error filtered cityes header');
                        this.currentPhone = '+7(727) 2 777-777';
                    }
                }
            },
            setLocale(lang) {
                localStorage.setItem('languageShablon', lang);
                document.location.reload(true);
            },
            changeLang () {
                this.dataLang = window.body.data('language');
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.isMobileCheck();
            this.checkResize();
            this.changeLang();
            this.filterPhoneCity()
            this.$store.watch(
                (state) => state.currentCity,
                (newValue) => {
                    this.filterPhoneCity();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-nav.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-nav-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>